import { schema } from 'normalizr';
// import * as rawMatSchemas from '../rawMat/rawMatSchemas';
// import * as productSchemas from '../product/productSchemas';

export const productCategorySchema = new schema.Entity('productsCategories', {}, { idAttribute: 'ProductCategoryId' });
export const productCategoryListSchema = [productCategorySchema];
  